import PROFILE from './info/profile'
import PRODUCTS from './info/products'

const COLLECTION_ICONS_DIR = '/static/img/recommend/lp/common/collection_icons/'
export const colorScheme = {
  keyColor: '#303030',
  second: '#6799CB',
  gradStart: '#4F65B2',
  gradEnd: '#6799CB',
  buttonBackground: 'linear-gradient(270deg, #f2d15d 0%, #fda553 51.04%, #ee545e 100%)',
  baseBg: '#9C8961', // ヘッダ用のBGとして使用(指定がない場合はgradStart,gradEndを使用し標準パラメータでグラデーションを描画)
  infoBg: '#f1f8ff',
  messBg: '#F9F5ED',
  profileKeyColor: '#6799CB',
}

const pathCommon = '/static/img/recommend/lp/common/'
const pathCounselor = '/static/img/recommend/lp/touwa/'
const deco = ''
const kira = `${pathCounselor}kira.png`
const counselor = `${pathCounselor}counselor.png`

const SUBSC_MENU_NUM = 70 //サブスクメニュー数

const hero = {
  pc: `${pathCounselor}top_sp_20221003.webp`,
  sp: `${pathCounselor}top_sp_20221003.webp`,
  fallback_pc: `${pathCounselor}top_sp_20221003.png`,
  fallback_sp: `${pathCounselor}top_sp_20221003.png`,
  alt: '人の可能性を極限化する「属性開抛」の開祖',
}

const about = {
  // deco: deco,
  img: `${pathCounselor}about.webp`,
  headline: '斗弥（とうわ）とは',
  text: '老舗クラブでのホスト経験を持つ異色の占い師。数奇な運命に引き寄せられ赴いた熊本で、占いカフェバーのオーナーになり、地元メディアの常連となる。<br>ホスト時代に鍛えた人間観察力を土台にしたわかりやすい表現で、心のひだまで届く鑑定を行い、自分らしい生き方を探す老若男女に人気を博している。',
}

const fortune = {
  // deco: deco,
  headline: '属性開抛（ぞくせいかいほう）とは',
  text: '五行の属性から各々の方法を導く、持って生まれた気質を最大限に生かす開運法。あなたに〈宿る神〉と〈守り星〉、そして〈属性〉の3つで占う。',
  kira,
  you: {
    headline: '属性開抛で見る<br>あなたのこと',
    text: '自分らしい生き方が見つからないあなたへ。<br>属性開抛はあなたに合った開運法を教えます。',
    comment: '持って生まれた気質を理解すれば、その人に合った開運法はおのずと見つかります。<br>あなたという人をよく観察し、優しく紐解いていきましょう。',
    counselorImage: counselor,
    avatar: `${pathCommon}avatar.png`,
    sample: [
      {
        icon: `${pathCounselor}img_kekka1.png`,
        label: 'クシナダ',
        text: '誰かのサポートが得意だが、迷いやすい',
      },
      {
        icon: `${pathCounselor}img_kekka2.png`,
        label: '辰星',
        text: '仕事や外での活動より、プライベートが大事',
      },
    ],
    // advice: '自分の運命を組み立てて、<br>幸せを掴みに行きましょう。',
    advice: '2回連続、ゲストタレントが<br>「<span style="color:#7199c7;">クシナダ 歳星 火</span>」！<br>同じ星を持つ2人に対し、<br>＼<span style="margin: 0 27px;">斗弥の見立ては？</span>／',
  },
  method: {
    headline: '頑張っているのに、<br>何故か幸せを感じられないなら<br>その頑張り方はあなたに合っていないのかもしれません',
    text: '属性開抛が基本とするのは、あなたに〈宿る神〉と〈守り星〉、そして〈属性〉の3つ。<br>あなたの本質や大切にすべきこと、ライフワークバランスなど、“あなたにとってちょうど良い”がどこにあるか分からないと、生きづらいと感じてしまうことでしょう。',
    counselorImage: counselor,
    avatar: `${pathCommon}avatar.png`,
    sample: [
      {
        icon: `${pathCounselor}img_kekka3.png`,
        label: 'シナツ',
        text: 'たまにはワガママを言って自分に甘くなろう',
      },
      {
        icon: `${pathCounselor}img_kekka4.png`,
        label: '明星',
        text: 'オンオフともに、好きなことに全力投球',
      },
    ],
    advice: '属性開抛で開運すれば<br>あなたらしい<br>生き方に繋がります',
  },
  free: {
    text: '自分のタイプが気になった方は、こちらから診断できますよ',
    img: `${pathCounselor}counselor2.png`,
  }
}

const review = {
  // deco: deco,
}

const menu = {
  title: '斗弥の占いを<br>見てみる',
  // deco: deco,
}

const uTV = {
  // deco: deco,
  counselorImage: `${pathCounselor}counselor3.png`,
  lead: 'あなたらしさを<br>もっと追及するなら',
  resultBottomCap: `${PROFILE.name}の占いが<br>月額528円（税込）で<br>${SUBSC_MENU_NUM}メニュー占い放題！`
}

export const reviews = [
  { icon: `${pathCommon}icon_review1.png`, review: 'ここで占ってもらったことが、後日、本当に起きたので危機回避できました…。それ以来、困ったことがあると相談させてもらっています！' },
  { icon: `${pathCommon}icon_review2.png`, review: '悩みある時にふらっと先生に、仕事のことで占ってもらいました。これから進む道しるべを教えて、今では、安心して進むことが出来ています。' },
  { icon: `${pathCommon}icon_review3.png`, review: 'よくある占いって、しっくりしない結果が多いけど、先生のアドバイスはスルスルと理解できる不思議な体験でした。悩みもあっという間に解けた気がします！' },
]

const title = {
  subTitle: '宿る神・守り星・属性で自分がわかる',
  title: '斗弥の属性開抛'
}

const fortuneResult = {
  lead: 'あなたに<b>宿る神</b>は',
}

const snsShare = {
  lead: '宿る神をシェアする',
}

const leadMenu = {
  // deco: deco,
  counselorImage: `${pathCounselor}counselor4.png`,
  comment: '<b>属性開抛は、生まれ持った気質を最大限に生かす占いです。<br>つづいて〈守り星〉〈属性〉で、あなたの可能性を極限化しましょう。</b>',
  // lead: 'あなたのこと、<br>大切な人とのことを<br>詳しく見るなら',
}

const aboutType = {
  // deco: deco,
  title: '「守り星」で才能を知り、<br>「属性」で運気を活性化する',
  lead: 'あなたの基本属性',
  zokusei: '才能をフル発揮するには',
  unkiup: '運気アップのカギ',
}

const leadSubsc = {
  // deco: deco,
}

// const advice = {
//   deco: deco,
//   counselorImage: `${pathCounselor}counselor5.png`,
// }

const title2 = {
  // deco: deco,
  subTitle: '＼あなたの周りの人は何タイプ？／',
  title: '斗弥の属性開抛で<br>占ってみよう',
}

const floatingBanner = {
  enable: true,
  title: '<span class="name">斗弥</span>の<span class="emphasis">属性開抛</span>で',
  freeBtnFace: '無料で占う',
  colors: {
    background: colorScheme.messBg,
    baseText: '#00462e',
    emphasis: colorScheme.baseBg,
    decos: colorScheme.baseBg,
    freeBtn: colorScheme.gradEnd,
    freeBtnBg: 'white',
  }
}

const menuDetails = {
  colors: {
    headBg: colorScheme.baseBg,
    headColor: colorScheme.messBg,
    baseBg: colorScheme.messBg,
    baseColor: 'black',
    resultBg: '#f2f2f2',
  },
  contents: [
    { icon: `${COLLECTION_ICONS_DIR}icon_collection1.png`, description: '属性開抛とカードで占う<br>恋の未来' },
    { icon: `${COLLECTION_ICONS_DIR}icon_collection2.png`, description: 'ＴＶと同じ占い！<br>今の運気と成功法' },
    { icon: `${COLLECTION_ICONS_DIR}icon_collection3.png`, description: 'あなたの運命の恋、<br>結婚絶対相性 etc' },
    { icon: `${COLLECTION_ICONS_DIR}icon_collection4.png`, description: '開運！！！<br>あなたの金運を徹底強化 etc' },
    { icon: `${COLLECTION_ICONS_DIR}icon_collection5.png`, description: 'あの人と<br>うまくやっていくコツ etc' },
    { icon: `${COLLECTION_ICONS_DIR}icon_collection6.png`, description: '約束された成功、<br>今年起こる事件 etc' },
  ],
}

const tabedMenu = {
  color: {
    baseColor: colorScheme.second,
    itemFont: colorScheme.baseBg,
    frameColor: colorScheme.baseBg,
  }
}

const lineBanner = {
  bannerUrl: '/static/img/recommend/lp/banner/touwa_line_20220316.png'
}

const uTvDesc = {
  leadImg: `${pathCounselor}counselor6.png`,
  lead: 'いかがでしたか？<br>誰にでも長所があれば、短所もあります。そして自分にとっては短所だと思っている部分が、実は人からうらやましがられることも。<br>見方を変えれば、どちらにも転ぶんです。あなたの持って生まれた性質を活かして、幸せな人生を送るためにはどうすればいいのか？<br>もう少し占っていきますね。<br><br>次は、あなたが生まれ持った「宿命」と「運命の人」について、見ていきましょう。',
  points: [{
    img: `${pathCounselor}uTVdesc/point1.png`,
    copy: `${pathCounselor}uTVdesc/point1_copy.png`,
  },{
    img: `${pathCounselor}uTVdesc/point2.png`,
    copy: `${pathCounselor}uTVdesc/point2_copy.png`,
  },{
    img: `${pathCounselor}uTVdesc/point3.png`,
    copy: `${pathCounselor}uTVdesc/point3_copy.png`,
  },{
    img: `${pathCounselor}uTVdesc/point4.png`,
    copy: `${pathCounselor}uTVdesc/point4_copy.png`,
  },{
    img: `${pathCounselor}uTVdesc/point5.png`,
    copy: `${pathCounselor}uTVdesc/point5_copy.png`,
  },{
    img: `${pathCounselor}uTVdesc/point6.png`,
    copy: `${pathCounselor}uTVdesc/point6_copy.png`,
  },],
}

const resultSelectMenu = [
  { title: '【属性開抛】あなたに約束された成功の果実', price: '', url: '', gaLabel: '0401' },
  { title: '【属性開抛】その出会いが持つ意味と本来の定め', price: '', url: '', gaLabel: '0401' },
  { title: '【属性開抛】詳細版・人生の「変わり目」', price: '', url: '', gaLabel: '0401' },
  { title: '【タロット】次に起こる出来事を占う斗弥タロット', price: '', url: '', gaLabel: '0401' },
  { title: '【タロット】あの人はあのときのあなたをどう思った？', price: '', url: '', gaLabel: '0401' },
  { title: '【タロット】元恋人は私のことを今どう思ってる？', price: '', url: '', gaLabel: '0401' }
]

export const information = {
  name: PROFILE.name, // ※互換のため残すが以降についてはprofile.nameを使用すること
  mainMethod: PROFILE.mainMethod, // ※互換のため残すが以降についてはprofile.mainMethodを使用すること
  profile: PROFILE,
  products: PRODUCTS,
  hero,
  about,
  fortune,
  review,
  reviews,
  menu,
  uTV,
  title,
  fortuneResult,
  snsShare,
  leadMenu,
  aboutType,
  leadSubsc,
  // advice,
  title2,
  floatingBanner,
  menuDetails,
  lineBanner,
  tabedMenu,
  uTvDesc,
  resultSelectMenu
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/recommend/lp/counselor/touwa/counselorInfos.js